import "./OpenTraderHelpWidgetComponent.scss";
import template from "./OpenTraderHelpWidgetComponent.html";
import {IComponentOptions} from "angular";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {ReplaySubject} from "rxjs";

export const OpenTraderHelpWidget = "tfOpenTraderHelpWidget";

export function openTraderHelpWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            displayMode: "<"
        },
        controllerAs: "ctrl",
        controller: OpenTraderHelpWidgetComponentController
    };
}

export class OpenTraderHelpWidgetComponentController {
    /** @input */
    public set displayMode(displayMode: WidgetDisplayMode | null) {
        if (displayMode != null) {
            this.displayMode$.next(displayMode);
        }
    }

    private readonly displayMode$ = new ReplaySubject<WidgetDisplayMode>(1);

}
